<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.66667 10C2.66667 5.94991 5.94991 2.66667 10 2.66667C14.0501 2.66667 17.3333 5.94991 17.3333 10C17.3333 14.0501 14.0501 17.3333 10 17.3333C5.94991 17.3333 2.66667 14.0501 2.66667 10ZM10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5ZM9.99967 6.11336C10.4139 6.11336 10.7497 6.43516 10.7497 6.83211C10.7497 7.22907 10.4139 7.55086 9.99967 7.55086C9.58546 7.55086 9.24967 7.22907 9.24967 6.83211C9.24967 6.43516 9.58546 6.11336 9.99967 6.11336ZM9.9943 13.6168C10.3165 13.6168 10.5776 13.3556 10.5776 13.0334V9.58127C10.5776 9.25911 10.3165 8.99794 9.9943 8.99794C9.67214 8.99794 9.41097 9.25911 9.41097 9.58127V13.0334C9.41097 13.3556 9.67214 13.6168 9.9943 13.6168Z"
      fill="white"
      fill-opacity="0.54"
    />
  </svg>
</template>

<script lang="ts">
export default {
  data() {
    return {};
  },
};
</script>
